/**
 * FOOTER ENTRY POINT
 *
 * The footer component contains the logo and the navigation links.
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import utils from './../../utils/utilities';

function Footer({version, interfaceLanguage}) {
    const appVersion = version ? version : null;
    const currentDate = new Date();
    const copyrightYear = currentDate.getFullYear();

    return (
        /* Add the "notranslate" class so that Google Translate doesn't change the footer when in Preview Article */
        <div className="footer no-print">
            <div className="footer__wrapper">
                <a href="http://bis.lexisnexis.co.uk/"
                   target="_blank"
                >
                    <span className=" footer__logo--lexis"></span>
                </a>
                <div className="footer__links">
                    <a href="http://bis.lexisnexis.co.uk/"
                       target="_blank"
                       className="footer__link footer__link--about">
                        <FormattedMessage id="HeaderFooterNav_Legal_UIText_footer.about"/>
                        <sup>&reg;</sup>
                    </a>

                    <a href="https://www.lexisnexis.com/product-resources/nexis/privacy-policy.html"
                       target="_blank"
                       className="footer__link">
                        <FormattedMessage id="HeaderFooterNav_Legal_UIText_footer.privacy"/>
                    </a>

                    <a href="https://www.lexisnexis.com/global/privacy/processing-notice.page?srsltid=AfmBOorMZs1gEzTUy5PCUe4BESIloxXMA19mj9SLyDPPA8QA7KQ7z0cc "
                       target="_blank"
                       className="footer__link">
                        <FormattedMessage id="HeaderFooterNav_Legal_UIText_footer.processing"/>
                    </a>

                    <button className="ot-cookie-btn" onClick={() => window.OneTrust && window.OneTrust.ToggleInfoDisplay()}>
                        <FormattedMessage id="HeaderFooterNav_Legal_UIText_footer.cookies"/>
                    </button>

                    <a href={utils.getTermsAndConditionsLink(interfaceLanguage)}
                       target="_blank"
                       className="footer__link">
                        <FormattedMessage id="HeaderFooterNav_Legal_UIText_footer.terms"/>
                    </a>

                    <a href="https://www.lexisnexis.com/terms/copr/lngp/uk/"
                       target="_blank"
                       className="footer__link">
                        <span>&copy; </span>
                        {copyrightYear}
                        &nbsp;
                        <FormattedMessage id="HeaderFooterNav_Legal_UIText_footer.copyright"/>
                    </a>
                </div>
                <a href="http://www.relx.com/"
                   target="_blank"
                >
                    <span className="footer__logo--relx"></span>
                </a>
            </div>

            <div className="version">
                <div>
                    <div><FormattedMessage id="General_CoreFunctionality_UIText_general.version"/>-{process.env.REACT_APP_BUILD_VERSION}</div>
                    <div><FormattedMessage id="General_CoreFunctionality_UIText_general.version"/>-{appVersion}</div>
                </div>
            </div>

        </div>

    );

}

export default Footer;


// WEBPACK FOOTER //
// ./src/scripts/reusable/Footer/Footer.index.jsx